import { useMemo } from 'react';

import { ClubTable } from '@blocks';
import { useClubCollections, useSelectUserClub, useUserClubs } from '@queries';
import { Spinner, Text } from '@ui';
import { useTranslate } from '@i18n';

import * as css from './BagSection.css';

export const BagSection = ({ activeUserId }: { activeUserId?: string }) => {
    const { data: clubs } = useClubCollections();
    const { data: userClubs } = useUserClubs(activeUserId);
    const { mutateAsync: selectClub } = useSelectUserClub(activeUserId);
    const userClubIds = useMemo(() => userClubs?.map((club) => club.id) || [], [userClubs]);
    const t = useTranslate();

    return (
        <div className={css.bagSettings}>
            <Text variant="h2">{t('user_settings.my_golf_bag')}</Text>
            {!clubs ? (
                <Spinner size="l" />
            ) : (
                <ClubTable clubs={clubs} selectedClubs={userClubIds} onClubClick={selectClub} />
            )}
        </div>
    );
};
